<!-- <app-login></app-login> -->
<app-home></app-home>
<ng-keyboard-shortcuts [shortcuts]="shortcuts"></ng-keyboard-shortcuts>